import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$availableUsers$it, _vm$availableUsers$it2, _vm$availableUsers$it3;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.hasAccessToPage ? _c("Error", {
    attrs: {
      error: {
        title: "Access not granted",
        description: "You are not allowed to access to this functionality.",
        link: "userHome",
        linkTitle: "home"
      }
    }
  }) : [_c(VDialog, {
    attrs: {
      width: "95%",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyFocused && !_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Upload tasting photo")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) || _vm.isConsultantOrHolding(_vm.loggedUserData) ? [!_vm.userIdTarget ? _c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: ((_vm$availableUsers$it = _vm.availableUsers.items) === null || _vm$availableUsers$it === void 0 ? void 0 : _vm$availableUsers$it.length) <= 0,
      items: _vm.availableUsers.items,
      "item-value": "id",
      "item-text": "name",
      label: _vm.availableUsers.isPending ? "Loading..." : ((_vm$availableUsers$it2 = _vm.availableUsers.items) === null || _vm$availableUsers$it2 === void 0 ? void 0 : _vm$availableUsers$it2.length) > 0 ? "Targeted user" : "No user available",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.changeUserTarget();
      }
    },
    model: {
      value: _vm.userIdTarget,
      callback: function callback($$v) {
        _vm.userIdTarget = $$v;
      },
      expression: "userIdTarget"
    }
  })], 1) : _c("div", [_vm._v(" Final customer : " + _vm._s((_vm$availableUsers$it3 = _vm.availableUsers.items) === null || _vm$availableUsers$it3 === void 0 ? void 0 : _vm$availableUsers$it3.find(function (x) {
    return x.id === _vm.userIdTarget;
  }).name) + " ")])] : _vm._e(), !!_vm.userIdTarget ? [_c("div", {
    staticClass: "mt-default"
  }, [_c("UploaderV2", {
    key: "uploaderTastingPhoto",
    ref: "uploaderTastingPhoto",
    staticClass: "w100p",
    attrs: {
      url: _vm.urlAddPhoto,
      fileTypes: [".png", ".jpg", ".jpeg"],
      additionalFormData: _vm.formWithouValidNormalized,
      multiple: false,
      hideUploadButton: ""
    },
    on: {
      "click:upload": _vm.acknowledgeUpload,
      "upload:failed": _vm.uploadFailed,
      sync: _vm.syncFiles
    }
  })], 1), _c(VForm, {
    staticClass: "dfwa-form mt-default",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", [!_vm.isCommentShown ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.isCommentShown = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-comment mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a comment ")], 1) : _c(VTextarea, {
    attrs: {
      label: "Comment",
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "comment", $$v);
      },
      expression: "form.comment"
    }
  })], 1), _c("div", [_vm._v("Select the bottle(s) that can be seen on the photo")]), _vm._l(_vm.form.contents, function (content, index) {
    var _vm$form$contents;
    return _c("div", {
      key: "form-upload-content-" + index,
      staticClass: "form-upload-content"
    }, [_c(VAutocomplete, {
      attrs: {
        disabled: _vm.availablePhotosRequired.isPending,
        items: _vm.availablePhotosRequired.items,
        "item-value": "id",
        "item-text": "name",
        label: !_vm.availablePhotosRequired.isPending ? "Wine" : "Loading...",
        "hide-details": "auto",
        rules: [_vm.formRules.mustSelectValue]
      },
      model: {
        value: content.tastingPhotoRequiredId,
        callback: function callback($$v) {
          _vm.$set(content, "tastingPhotoRequiredId", $$v);
        },
        expression: "content.tastingPhotoRequiredId"
      }
    }), _c(VTextField, {
      attrs: {
        disabled: !content.tastingPhotoRequiredId > 0,
        label: "Nb bottles",
        "hide-details": "auto",
        type: "number",
        min: 1,
        rules: [_vm.formRules.mustBeGreaterThan0]
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: content.nbBottles,
        callback: function callback($$v) {
          _vm.$set(content, "nbBottles", $$v);
        },
        expression: "content.nbBottles"
      }
    }), ((_vm$form$contents = _vm.form.contents) === null || _vm$form$contents === void 0 ? void 0 : _vm$form$contents.length) > 1 ? _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.removeContent(index);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-minus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Remove this wine ")], 1) : _vm._e()], 1);
  })], 2), _c("div", {
    staticClass: "mt-default"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addContent();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add an other wine ")], 1)], 1)] : _vm._e(), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.canBeSubmitted || _vm.isAnyFocused || _vm.isAnyActionInProgress,
      loading: _vm.isSaving
    },
    on: {
      click: function click($event) {
        return _vm.submitCreationForm();
      }
    }
  }, [_vm._v(" Upload ")])], 1)], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  })]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };